import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import App from "./containers/app/App";
import Payment from "./containers/payment/Payment";
import Jump from "./components/jump/jump";
import { store } from "./app/store";
import ScrollToTop from './components/scroll-to-top/ScrollToTop';
import "./index.css";
import PickupLocation from "./components/pickup-location/PickupLocation";
import LessonSearch from "./containers/lesson-search/LessonSearch";
import ShowProducts from "./containers/show-products/ShowProducts";
import PreviousStepCompleteRoute from "./components/previous-step-complete-route/PreviousStepCompleteRoute";
import { appRoutes } from "./containers/app/Routes";

const container = document.getElementById("root");
if (container) {
  const publicURL = import.meta.env.VITE_PUBLIC_URL ? import.meta.env.VITE_PUBLIC_URL : '/';

  const router = createBrowserRouter(
    [
      {
        path: "/",
        element: (
          <ScrollToTop>
            <App />
          </ScrollToTop>
        ),
        children: [
          { path: "", element: <ShowProducts /> }, // Default child route
          ...appRoutes.map((route) => ({
            path: route.path.startsWith("/") ? route.path.slice(1) : route.path, // Ensure relative paths
            element: (
              <PreviousStepCompleteRoute
                routeName={route.name}
                component={route.component}
              />
            ),
          })),
        ],
      },
    ],
    {
      basename: publicURL, // Set the basename here
    }
  );

  const root = createRoot(container);

  root.render(
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  );
} else {
  throw new Error(
    "Root element with ID 'root' was not found in the document. Ensure there is a corresponding HTML element with the ID 'root' in your HTML file."
  );
}